import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppStateService } from 'src/app/services/app-state.service';

@Component({
  selector: 'app-send-charges',
  templateUrl: './send-charges.component.html',
  styleUrls: ['./send-charges.component.scss']
})
export class SendChargesComponent implements OnInit {

  constructor(private appState: AppStateService, private router: Router) { }

  ngOnInit() {
  }

  next() {
    this.appState.setLoading(true).then(() => {
      setTimeout(() => {
        this.router.navigate(['success']);
        this.appState.setLoading(false);
      }, 3000);
    });
  }

}
